
















































import Vue from 'vue'
import Block from '@/components/Block.vue'
import EmailValidation from '@/service/EmailValidation'
import BackgroundLayout from '@/components/BackgroundLayout.vue'
import ExpandableText from '@/components/ExpandableText.vue'

export default Vue.extend({
  name: 'Contact',
  components: {
    Block,
    BackgroundLayout,
    ExpandableText,
  },
  async mounted() {
    const promises = [
      this.$api
        .get('/articles/slug/contact-consent-short')
        .then((result) => (this.consentShort = result.data.content)),
      this.$api
        .get('/articles/slug/contact-consent-long')
        .then((result) => (this.consentLong = result.data.content)),
    ]

    Promise.all(promises).then(() => (this.contentLoaded = true))
  },
  data: () => ({
    consentShort: '',
    consentLong: '',
    contentLoaded: false,
    sendLoading: false,
    name: '',
    email: '',
    message: '',
    nameRules: [(v: string) => !!v || 'Your name is required.'],
    emailRules: [
      (v: string) => !!v || 'Your e-mail is required.',
      (v: string) =>
        EmailValidation.isValid(v) || 'Enter correct e-mail address.',
    ],
    messageRules: [(v: string) => !!v || 'Message is required.'],
  }),
  methods: {
    sendEmail: async function () {
      this.sendLoading = true
      await this.$recaptchaLoaded()
      const token = await this.$recaptcha('contact')
      this.$api
        .post('/contacts', {
          name: this.name,
          email: this.email,
          message: this.message,
          token: token,
        })
        .then((response) => {
          this.name = ''
          this.email = ''
          this.message = ''
          ;(this.$refs.contactFormRef as any).resetValidation()
          this.$store.dispatch(
            'alert/success',
            'Message has been sent. We will try to reply as soon as possible.'
          )
        })
        .catch(() =>
          this.$store.dispatch('alert/error', 'Problems with sending message.')
        )
        .finally(() => (this.sendLoading = false))
    },
  },
  beforeDestroy() {
    this.$recaptchaInstance.hideBadge()
  },
})
